// extracted by mini-css-extract-plugin
module.exports = {"event":"event__uVRg1"};